import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home/home.component';
import { ToolsModule } from '../tools/tools.module';
import { TranslateprojectModule } from '../pipes/translate/translateproject.module';
import { IntroComponent } from './home/home-sections/intro/intro.component';
import { HowToPlayComponent } from './home/home-sections/how-to-play/how-to-play.component';
import { WhatIsComponent } from './home/home-sections/what-is/what-is.component';
import { AboutComponent } from './home/home-sections/about/about.component';

@NgModule({
  declarations: [HomeComponent, IntroComponent, HowToPlayComponent, WhatIsComponent, AboutComponent],
  imports: [CommonModule, HomeRoutingModule, ToolsModule, MatCardModule, TranslateModule, TranslateprojectModule]
})
export class HomeModule {}
